import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const UniversitySubjectEdit = () => {
  const [subjectName, setSubjectName] = useState("");
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [courses, setCourses] = useState([]);
  const [semesterId, setSemesterId] = useState("");
  const [semesters, setSemesters] = useState([]);
  const [subjectUploadIcon, setSubjectUploadIcon] = useState(null);

  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");

  const handleAddCategory = () => {
    if (selectCategory && !category.includes(selectCategory)) {
      setCategory([...category, selectCategory]);
      setSelectCategory(""); // reset dropdown
    }
  };

  const handleRemoveCategory = (cat) => {
    setCategory(category.filter((item) => item !== cat));
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const { id } = useParams();
  const navigate = useNavigate();

  // Load subject data
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/college-subject/${id}`)
      .then((response) => {
        const subjectData = response.data?.data;
        setSubjectName(subjectData.subjectName);
        setUniversityId(subjectData.universityId);
        setCourseId(subjectData.courseId);
        setSemesterId(subjectData.semesterId);
        setSubjectUploadIcon(subjectData.icon);
        setCategory(subjectData.category || []);
      })
      .catch((error) => console.log("Error fetching subject data:", error));
  }, [id, API_BASE_URL]);

  // Load universities and semesters data
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => setUniversities(response.data?.data || []))
      .catch((error) => console.log("Error fetching universities:", error));

    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => setSemesters(response.data?.data || []))
      .catch((error) => console.log("Error fetching semesters:", error));
  }, [API_BASE_URL]);

  // Load courses based on selected university
  useEffect(() => {
    if (universityId) {
      axios
        .get(`${API_BASE_URL}/all-courses/${universityId}`)
        .then((response) => setCourses(response.data?.data || []))
        .catch((error) => console.log("Error fetching courses:", error));
    }
  }, [universityId, API_BASE_URL]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("subjectName", subjectName);
    formData.append("universityId", universityId);
    formData.append("courseId", courseId);
    formData.append("semesterId", semesterId);

    if (subjectUploadIcon) {
      formData.append("icon", subjectUploadIcon);
    }

    if (category.length > 0) {
      category.forEach((cat) => {
        formData.append("category", cat);
      });
    }

    try {
      await axios.put(`${API_BASE_URL}/college-subject/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("Subject updated successfully");
      navigate("/college-all-subject");
    } catch (error) {
      console.error("Error updating subject:", error);
      alert("Error updating subject");
    }
  };

  return (
    <div id="add-college-course-wrapper">
      <div className="course-header-with-btns">
        <h5>Subject</h5>
        <div className="college-course-nav-btns">
          <Link to={"/college-subject"}>
            <button className="college-add-course-add-btn">
              + Add New Subject
            </button>
          </Link>
          <Link to={"/college-all-subject"}>
            <button className="college-all-course-btn">All Subject</button>
          </Link>
        </div>
      </div>

      <div className="add-college-course-inner-main-wrapper">
        <div className="form-main-container">
          <h4 className="college-course-detail">Update Subject</h4>
          <form onSubmit={handleSubmit} className="college-course-detail-form">
            {/* <div className="new-chapter-form-group">
              <label className="new-chapter-label">Select University</label>
              <select
                className="new-chapter-dropdown"
                value={universityId}
                onChange={(e) => setUniversityId(e.target.value)}
                required
              >
                <option value="">-Select University-</option>
                {universities.map((university) => (
                  <option key={university._id} value={university._id}>
                    {university.universityName}
                  </option>
                ))}
              </select>
            </div> */}
            {/* <div className="new-chapter-form-group">
              <label className="new-chapter-label">Course Name</label>
              <select
                className="new-chapter-dropdown"
                value={courseId}
                onChange={(e) => setCourseId(e.target.value)}
                required
              >
                <option value="">-Select Course-</option>
                {courses.map((course) => (
                  <option key={course._id} value={course._id}>
                    {course.courseName}
                  </option>
                ))}
              </select>
            </div> */}
            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Semester</label>
              <select
                className="new-chapter-dropdown"
                value={semesterId}
                onChange={(e) => setSemesterId(e.target.value)}
                required
              >
                <option value="">-Select Semester-</option>
                {semesters.map((semester) => (
                  <option key={semester._id} value={semester._id}>
                    {semester.semesterName}
                  </option>
                ))}
              </select>
            </div>
            <div className="input-group">
              <label className="label">Subject Name</label>
              <input
                style={{
                  marginLeft: "1px",
                  borderBottomLeftRadius: "5px",
                  borderTopLeftRadius: "5px",
                }}
                type="text"
                value={subjectName}
                onChange={(e) => setSubjectName(e.target.value)}
                placeholder="Enter Subject Name..."
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Upload Icon</label>
              </div>
              <input
                type="file"
                id="subject-upload-icon"
                onChange={(e) => setSubjectUploadIcon(e.target.files[0])}
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Select Category</label>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <select
                  className="school-class-add-input-tag"
                  value={selectCategory}
                  onChange={(e) => setSelectCategory(e.target.value)}
                >
                  <option value="">-Select Category-</option>
                  <option
                    value="Assignment"
                    disabled={category.includes("Assignment")}
                  >
                    Assignment
                  </option>
                  <option
                    value="Subjective_Exam"
                    disabled={category.includes("Subjective_Exam")}
                  >
                    Subjective Exam
                  </option>
                  <option
                    value="Exam_Notes"
                    disabled={category.includes("Exam_Notes")}
                  >
                    Exam Notes
                  </option>
                  <option
                    value="video_section"
                    disabled={category.includes("video_section")}
                  >
                    Video Section
                  </option>
                </select>
                <button
                  type="button"
                  onClick={handleAddCategory}
                  className="btn-s"
                >
                  Add
                </button>
              </div>
            </div>

            {category.length > 0 && (
              <div className="selected-categories">
                <p style={{ marginBottom: "5px" }}>Selected Categories:</p>
                <ul>
                  {category.map((cat, index) => (
                    <li key={index} style={{ marginBottom: "5px" }}>
                      {cat.replaceAll("_", " ")}
                      <button
                        type="button"
                        onClick={() => handleRemoveCategory(cat)}
                        style={{
                          marginLeft: "10px",
                          background: "red",
                          color: "white",
                          border: "none",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="college-course-form-btns">
              <button className="btn-search" type="submit">
                Save
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={() => navigate("/college-all-subject")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UniversitySubjectEdit;
